module.exports = __webpack_public_path__ + "img/information-icon-red.74506d6c.svg";